export default __webpack_public_path__ + "static/media/edit.d1d986c1.svg";